import React from 'react';
import Headroom from 'react-headroom';
import { Flex, Image, Text, Box, Link, Button } from 'rebass/styled-components';
import styled from 'styled-components';
import { Link as GatsbyLink } from 'gatsby';

import LupusCornerLogo from '../../assets/images/lupuscorner-logo.svg';

const HeaderContainer = styled(Headroom)`
  width: 100%;

  .headroom--pinned {
    max-width: 600px;
    margin: auto;
    z-index: 100 !important;
  }

  .headroom--scrolled {
    max-width: 600px;
    margin: auto;
  }
`;

const StaticHeader = ({ onClick }) => {
  return (
    <Flex>
      <HeaderContainer>
        <Flex
          flexWrap="wrap"
          justifyContent="space-between"
          alignItems="center"
          height="50px"
          px={3}
          bg="white"
        >
          <GatsbyLink to="/">
            <Image src={LupusCornerLogo} width={'120px'} mt={'10px'}></Image>
          </GatsbyLink>
          <Button variant="secondary" onClick={onClick}>
            ENROLL NOW
          </Button>
        </Flex>
        <Box width="100%" height="1px" bg="#CECECE"></Box>
      </HeaderContainer>
    </Flex>
  );
};

export default StaticHeader;
